import { render } from "./AlterarSenha.vue?vue&type=template&id=3e0fc29a&scoped=true"
import script from "./AlterarSenha.vue?vue&type=script&lang=js"
export * from "./AlterarSenha.vue?vue&type=script&lang=js"

import "./AlterarSenha.vue?vue&type=style&index=0&id=3e0fc29a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0fc29a"]])

export default __exports__